package com.tixforgigs.common.core.enums

import com.tixforgigs.common.core.util.IdHelper.templateId
import com.tixforgigs.common.core.util.LocalizationUtil.requestedLanguageISOCode
import com.tixforgigs.common.http.HttpClient.CLIENT_TYPE

val basePath: String
  get() = when (CLIENT_TYPE) {
    ClientType.ARAI_STOREFRONT -> "$requestedLanguageISOCode/store/$templateId"
    ClientType.TEMPLATE_CONFIGURATOR -> ""
  }

sealed class View(val path: String) {
  object ABSOLUTE_ROOT : View("/")
  object RELATIVE_BASE_PATH_ROOT : View("$basePath/")

  object AUTHORIZE : View("/auth/authorize")
  object TOKEN : View("/auth/token")

  data object HOME : View("$basePath/home")
  data object ERROR : View("$basePath/error")
  data object EXAMPLE : View("$basePath/example")

  data object LOGIN : View("$basePath/account/login")
  data object FORGOT_PASSWORD : View("$basePath/account/forgot-password")

  data object RESET_PASSWORD : View("$basePath/account/reset-password")

  data object ACCOUNT : View("$basePath/account/overview")
  data object ORDERS : View("$basePath/account/orders")
  data object ACCOUNT_ADDRESS : View("$basePath/account/address")

  data object ACCOUNT_TICKETS : View("$basePath/account/tickets")

  data object ACCOUNT_PERSONAL_DATA : View("$basePath/account/me")

  data object ACCOUNT_BANKING : View("$basePath/account/banking")

  data object TEMPLATE_CONFIGURATIONS : View("$basePath/templates")

  data class TEMPLATE_CONFIGURATION(val templateId: String) : View("$basePath/templates/$templateId")

  data class TICKET_RESALE(val ticketId: String) : View("$basePath/account/resale/$ticketId")

  data object PAYMENT_START : View("$basePath/payment")
  data object PAYMENT_RESTART : View("$basePath/payment/restart")

  data class PAYMENT_REDIRECT(val sessionId: String? = null, val redirectResult: String? = null) : View(buildString {
    append("$basePath/payment/redirect")
    sessionId?.let { sessionId ->
      append("?session=$sessionId")
    }
    redirectResult?.let { redirectResult ->
      append("&result=$redirectResult")
    }
  })

  data object PAYMENT_EXTERNAL_WINDOW : View("$basePath/payment/external-window")

  data object EVENTS : View("$basePath/events")
  data class EVENT(val eventId: String) : View("$basePath/events/$eventId")

  data class ORDER(val orderId: String, val orderToken: String? = null) : View(buildString {
    append("$basePath/order/$orderId")
    orderToken?.let { token ->
      append("?token=$token")
    }
  })

  data class PREPAYMENT(val orderId: String, val orderToken: String) :
    View("$basePath/prepayment/$orderId/$orderToken")

}
